<template>
    <div class="store-card-list">
        <!-- 页面标题 -->
        <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
            <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>会员卡管理</el-breadcrumb-item>
            <el-breadcrumb-item>店铺卡列表</el-breadcrumb-item>
        </el-breadcrumb>

        <!-- 主要内容区域 -->
        <el-card class="box-card">
            <div class="store-card-container">
                <!-- 左侧店铺选择 -->
                <div class="store-selector">
                    <!-- 店铺搜索和状态筛选 -->
                    <div class="store-filters">
                        <!-- 店铺搜索 -->
                        <div class="store-search">
                            <el-input 
                                v-model="storeSearchKeyword" 
                                placeholder="搜索店铺名称" 
                                prefix-icon="el-icon-search"
                                size="small"
                                clearable
                                @input="filterStores">
                            </el-input>
                        </div>
                        <!-- 状态筛选按钮 -->
                        <div class="store-status-buttons">
                            <el-button 
                                :type="storeStatusFilter === '1' ? 'success' : 'default'"
                                :class="{ 'active-status-btn': storeStatusFilter === '1' }"
                                size="mini"
                                @click="setStatusFilter('1')">
                                <i class="el-icon-check"></i>
                                营业中
                            </el-button>
                            <el-button 
                                :type="storeStatusFilter === '3' ? 'warning' : 'default'"
                                :class="{ 'active-status-btn': storeStatusFilter === '3' }"
                                size="mini"
                                @click="setStatusFilter('3')">
                                <i class="el-icon-setting"></i>
                                装修中
                            </el-button>
                            <el-button 
                                :type="storeStatusFilter === '2' ? 'danger' : 'default'"
                                :class="{ 'active-status-btn': storeStatusFilter === '2' }"
                                size="mini"
                                @click="setStatusFilter('2')">
                                <i class="el-icon-close"></i>
                                已关闭
                            </el-button>
                            <el-button 
                                v-if="storeStatusFilter"
                                type="info" 
                                size="mini" 
                                plain
                                @click="clearStatusFilter()">
                                <i class="el-icon-refresh"></i>
                                全部
                            </el-button>
                        </div>
                    </div>
                    <div class="store-list">
                        <el-scrollbar style="height: 800px;">
                            <div 
                                v-for="store in filteredStoreList" 
                                :key="store.id"
                                :class="['store-item', { 'active': selectedStore && selectedStore.id === store.id }]"
                                @click="selectStore(store)">
                                <div class="store-header">
                                    <div class="store-name">{{ store.storename }}</div>
                                    <div class="store-status">
                                        <el-tag 
                                            :type="getStoreStatusType(store.isopen)" 
                                            size="mini" 
                                            effect="dark">
                                            {{ getStoreStatusText(store.isopen) }}
                                        </el-tag>
                                    </div>
                                </div>
                                <div class="store-info">
                                    <div class="store-city" :style="{ color: getCityColor(store.city) }">
                                        <i class="el-icon-location"></i>
                                        {{ store.city || '未设置城市' }} - {{ store.county || '' }}
                                    </div>
                                    <div class="store-address" v-if="store.address">
                                        <i class="el-icon-map-location"></i>
                                        {{ store.address }}
                                    </div>
                                </div>
                                <div class="store-extra" v-if="store.telephone">
                                    <i class="el-icon-phone"></i>
                                    {{ store.telephone }}
                                </div>
                            </div>
                        </el-scrollbar>
                    </div>
                </div>

                <!-- 右侧卡片列表 -->
                <div class="card-list-area">
                    <div v-if="!selectedStore" class="no-store-selected">
                        <el-empty description="请选择左侧店铺查看会员卡"></el-empty>
                    </div>
                    <div v-else>
                        <!-- 操作工具栏 -->
                        <div class="toolbar fitness-header">
                            <div class="fitness-background">
                                <div class="fitness-icons">
                                    <div class="fitness-icon dumbbell">🏋️</div>
                                    <div class="fitness-icon running">🏃</div>
                                    <div class="fitness-icon muscle">💪</div>
                                    <div class="fitness-icon heart">❤️</div>
                                    <div class="fitness-icon trophy">🏆</div>
                                </div>
                                <div class="fitness-waves">
                                    <div class="wave wave1"></div>
                                    <div class="wave wave2"></div>
                                    <div class="wave wave3"></div>
                                </div>
                            </div>
                            <div class="store-title">
                                <h3>{{ selectedStore.storename }} - 会员卡列表</h3>
                                <span class="card-count">共 {{ pagination.total }} 张卡片</span>
                            </div>
                            <div class="toolbar-actions">
                                <!-- <el-button 
                                    type="primary" 
                                    icon="el-icon-plus" 
                                    @click="openAddCardDialog"
                                    size="small">
                                    添加会员卡
                                </el-button> -->
                                <el-button 
                                    icon="el-icon-refresh" 
                                    @click="loadStoreCards"
                                    size="small">
                                    刷新
                                </el-button>
                            </div>
                        </div>

                        <!-- 搜索筛选区域 -->
                        <div v-if="selectedStore" class="search-filter-area">
                            <el-row :gutter="16">
                                <el-col :span="6">
                                    <el-input
                                        v-model="searchForm.cardname"
                                        placeholder="请输入会员卡名称"
                                        clearable
                                        @clear="handleSearch"
                                        @keyup.enter.native="handleSearch">
                                        <el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
                                    </el-input>
                                </el-col>
                                <el-col :span="5">
                                    <el-select 
                                        v-model="searchForm.cardclassid" 
                                        placeholder="卡类型" 
                                        clearable 
                                        @change="handleSearch">
                                        <el-option label="全部类型" value=""></el-option>
                                        <el-option label="时间卡" :value="1"></el-option>
                                        <el-option label="次卡" :value="2"></el-option>
                                        <el-option label="体验卡" :value="3"></el-option>
                                        <el-option label="学生卡" :value="4"></el-option>
                                        <el-option label="女神卡" :value="5"></el-option>
                                        <el-option label="店主卡" :value="6"></el-option>
                                        <el-option label="私教卡" :value="7"></el-option>
                                        <el-option label="早鸟卡" :value="9"></el-option>
                                        <el-option label="其他" :value="8"></el-option>
                                    </el-select>
                                </el-col>
                                <!-- <el-col :span="5">
                                    <el-select 
                                        v-model="searchForm.cardScopeType" 
                                        placeholder="适用范围" 
                                        clearable 
                                        @change="handleSearch">
                                        <el-option label="全部范围" value=""></el-option>
                                        <el-option label="单店卡" :value="1"></el-option>
                                        <el-option label="城市通卡" :value="2"></el-option>
                                        <el-option label="全国通卡" :value="3"></el-option>
                                        <el-option label="自定义组合" :value="4"></el-option>
                                    </el-select>
                                </el-col> -->
                                <el-col :span="4">
                                    <el-button @click="resetSearch">重置</el-button>
                                </el-col>
                                <el-col :span="4">
                                    <div class="total-info">
                                        共 {{ pagination.total }} 张卡
                                    </div>
                                </el-col>
                            </el-row>
                        </div>

                        <!-- 卡片列表表格 -->
                        <el-table 
                            :data="storeCardList" 
                            border 
                            size="small"
                            :row-style="{ height: '40px' }"
                            :cell-style="{ padding: '8px 12px' }"
                            style="width: 100%"
                            v-loading="loading">
                            <el-table-column prop="cardname" label="卡片名称"  align="center" width="320">
                                <template slot-scope="scope">
                                    <div class="card-name-cell">
                                        <span class="card-name">{{ scope.row.cardname }}</span>
                                        <el-tag 
                                            :type="getCardScopeTypeTag(scope.row.cardScopeType)" 
                                            size="mini">
                                            {{ getCardScopeTypeName(scope.row.cardScopeType) }}
                                        </el-tag>
                                    </div>
                                </template>
                            </el-table-column>

                            <el-table-column prop="cardclassid" label="特定描述"  align="center" width="120">
                                <template slot-scope="scope">
                                   
                                        {{ scope.row.storeDesc }}
                                  
                                </template>
                            </el-table-column>
                            
                            <el-table-column prop="cardclassid" label="卡片类型"  align="center" width="120">
                                <template slot-scope="scope">
                                    <el-tag :type="getCardClassTypeTag(scope.row.cardclassid)" size="mini">
                                        {{ getCardClassName(scope.row.cardclassid) }}
                                    </el-tag>
                                </template>
                            </el-table-column>
                            <el-table-column prop="price" label="价格" sortable align="center" width="100">
                                <template slot-scope="scope">
                                    <span class="price-text">¥{{ scope.row.price }}</span>
                                </template>
                            </el-table-column>
                             <el-table-column prop="days" label="天数" sortable align="center" width="100">
                                <template slot-scope="scope">
                                    <span class="price-text">¥{{ scope.row.days }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="sortOrder" label="排序" sortable align="center" width="100">
                                <template slot-scope="scope">
                                    <span class="sort-order">{{ scope.row.sortOrder || 0 }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="自动续费" align="center" width="90">
                                <template slot-scope="scope">
                                    <el-tag
                                        v-if="scope.row.isAutoRenewal == 1"
                                        type="success"
                                        size="small"
                                        style="cursor: pointer;"
                                        @click="showAutoRenewalDetail(scope.row)">
                                        已配置
                                    </el-tag>
                                    <el-tag v-else type="info" size="small">未配置</el-tag>
                                </template>
                            </el-table-column>
                            <el-table-column prop="isActive" label="状态"  align="center" width="100">
                                <template slot-scope="scope">
                                    <el-switch
                                        v-model="scope.row.isActive"
                                        :active-value="1"
                                        :inactive-value="0"
                                        @change="toggleCardStatus(scope.row)">
                                        <span slot="active-text" style="display: none;">启用</span>
                                        <span slot="inactive-text" style="display: none;">禁用</span>
                                    </el-switch>
                                    <el-tooltip :content="scope.row.isActive === 1 ? '启用' : '禁用'" placement="top">
                                        <span></span>
                                    </el-tooltip>
                                </template>
                            </el-table-column>
                            <el-table-column prop="createTime" label="创建时间"  align="center" width="140">
                                <template slot-scope="scope">
                                    {{ formatDate(scope.row.createTime) }}
                                </template>
                            </el-table-column>
                            <el-table-column prop="updateTime" label="修改时间"  align="center" width="140">
                                <template slot-scope="scope">
                                    {{ formatDate(scope.row.updateTime) }}
                                </template>
                            </el-table-column>
                            <el-table-column prop="createBy" label="创建人"  align="center" width="100">
                                <template slot-scope="scope">
                                    {{ scope.row.createBy || '-' }}
                                </template>
                            </el-table-column>
                            <el-table-column prop="updateBy" label="修改人" align="center" width="100">
                                <template slot-scope="scope">
                                    {{ scope.row.updateBy || '-' }}
                                </template>
                            </el-table-column>
                            <el-table-column label="操作" min-width="150" align="center" fixed="right">
                                <template slot-scope="scope">
                                    <el-button 
                                        type="text" 
                                        size="small" 
                                        @click="editStoreCard(scope.row)"
                                        icon="el-icon-edit">
                                        编辑
                                    </el-button>
                                    <el-button 
                                        type="text" 
                                        size="small" 
                                        @click="deleteStoreCard(scope.row)"
                                        icon="el-icon-delete"
                                        style="color: #f56c6c;">
                                        移除
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        
                        <!-- 分页组件 -->
                        <div v-if="selectedStore && pagination.total > 0" class="pagination-container">
                            <el-pagination
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page="pagination.pagenum"
                                :page-sizes="[10, 20, 50, 100]"
                                :page-size="pagination.pagesize"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="pagination.total">
                            </el-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </el-card>

        <!-- 添加会员卡弹窗 -->
        <el-dialog 
            title="为店铺添加会员卡" 
            :visible.sync="addCardDialogVisible" 
            width="600px"
            @close="resetAddCardForm">
            <el-form :model="addCardForm" :rules="addCardRules" ref="addCardForm" label-width="100px">
                <el-form-item label="选择会员卡" prop="cardId">
                    <el-select 
                        v-model="addCardForm.cardId" 
                        placeholder="请选择要添加的会员卡"
                        style="width: 100%"
                        filterable
                        @change="onCardSelect">
                        <el-option 
                            v-for="card in availableCards" 
                            :key="card.id" 
                            :label="card.cardname" 
                            :value="card.id">
                            <span style="float: left">{{ card.cardname }}</span>
                            <span style="float: right; color: #8492a6; font-size: 13px">{{ card.classname }}</span>
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="设置价格" prop="price">
                    <el-input-number 
                        v-model="addCardForm.price" 
                        :min="0" 
                        :precision="2" 
                        placeholder="请输入价格"
                        style="width: 100%">
                    </el-input-number>
                </el-form-item>
                <el-form-item label="排序" prop="sortOrder">
                    <el-input-number 
                        v-model="addCardForm.sortOrder" 
                        :min="0" 
                        placeholder="请输入排序值，数值越小越靠前"
                        style="width: 100%">
                    </el-input-number>
                </el-form-item>
                <el-form-item label="状态" prop="isActive">
                    <el-radio-group v-model="addCardForm.isActive">
                        <el-radio :label="1">启用</el-radio>
                        <el-radio :label="0">禁用</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="是否显示" prop="isShow">
                    <el-switch 
                        v-model="addCardForm.isShow" 
                        :active-value="1" 
                        :inactive-value="0" 
                        active-text="显示" 
                        inactive-text="隐藏">
                    </el-switch>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="addCardDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="confirmAddCard" :loading="submitting">确 定</el-button>
            </div>
        </el-dialog>

        <!-- 编辑会员卡弹窗 -->
        <el-dialog 
            title="编辑店铺会员卡" 
            :visible.sync="editCardDialogVisible" 
            width="600px"
            @close="resetEditCardForm">
            <el-form :model="editCardForm" :rules="editCardRules" ref="editCardForm" label-width="100px">
                <el-form-item label="会员卡名称">
                    <el-input v-model="editCardForm.cardname" disabled></el-input>
                </el-form-item>
                <!-- <el-form-item label="卡片类型">
                    <el-input v-model="editCardForm.classname" disabled></el-input>
                </el-form-item> -->
                <el-form-item label="设置价格" prop="price">
                    <el-input-number 
                        v-model="editCardForm.price" 
                        :min="0" 
                        :precision="2" 
                        placeholder="请输入价格"
                        style="width: 100%">
                    </el-input-number>
                </el-form-item>
                <el-form-item label="有效天数" prop="days">
                    <el-input-number 
                        v-model="editCardForm.days" 
                        :min="0" 
                        placeholder="请输入有效天数"
                        style="width: 100%">
                    </el-input-number>
                </el-form-item>
                <el-form-item label="特定描述" prop="storeDesc">
                    <el-input 
                        v-model="editCardForm.storeDesc" 
                        type="textarea"
                        :rows="3"
                        placeholder="请输入店铺特定描述"
                        maxlength="200"
                        show-word-limit>
                    </el-input>
                </el-form-item>
                <el-form-item label="排序" prop="sortOrder">
                    <el-input-number 
                        v-model="editCardForm.sortOrder" 
                        :min="0" 
                        placeholder="请输入排序值，数值越小越靠前"
                        style="width: 100%">
                    </el-input-number>
                </el-form-item>
                <el-form-item label="状态" prop="isActive">
                    <el-radio-group v-model="editCardForm.isActive">
                        <el-radio :label=1>启用</el-radio>
                        <el-radio :label=0>禁用</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="是否显示" prop="isShow">
                    <el-switch 
                        v-model="editCardForm.isShow" 
                        :active-value="1" 
                        :inactive-value="0" 
                        active-text="显示" 
                        inactive-text="隐藏">
                    </el-switch>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="editCardDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="confirmEditCard" :loading="submitting">确 定</el-button>
            </div>
        </el-dialog>

        <!-- 自动续费详情弹窗 -->
        <el-dialog
            title="自动续费配置详情"
            :visible.sync="autoRenewalVisible"
            width="700px"
            @close="autoRenewalData = null; autoRenewalDetails = []">
            <div v-if="autoRenewalData">
                <el-descriptions :column="2" border size="small">
                    <el-descriptions-item label="续费类型">
                        <el-tag type="primary" size="small">
                            {{ autoRenewalData.renewalType === 'MONTH' ? '连续包月' : autoRenewalData.renewalType === 'QUARTER' ? '连续包季' : autoRenewalData.renewalType === 'YEAR' ? '连续包年' : '-' }}
                        </el-tag>
                    </el-descriptions-item>
                    <el-descriptions-item label="扣款方式">微信委托代扣</el-descriptions-item>
                    <el-descriptions-item label="扣费周期">{{ autoRenewalData.deductCycle || '-' }}</el-descriptions-item>
                    <el-descriptions-item label="提前扣款天数">{{ autoRenewalData.advanceDeductDays == null ? '-' : autoRenewalData.advanceDeductDays }} 天</el-descriptions-item>
                    <el-descriptions-item label="失败重试次数">{{ autoRenewalData.retryTimes == null ? '-' : autoRenewalData.retryTimes }} 次</el-descriptions-item>
                </el-descriptions>
                <div style="margin-top: 16px;">
                    <h4 style="margin-bottom: 8px;">代扣明细</h4>
                    <el-table :data="autoRenewalDetails" border size="mini" max-height="300">
                        <el-table-column label="阶段" width="80" align="center">
                            <template slot-scope="scope">第{{ scope.row.phase }}期</template>
                        </el-table-column>
                        <el-table-column prop="originalPrice" label="原价" align="center">
                            <template slot-scope="scope">￥{{ scope.row.originalPrice }}</template>
                        </el-table-column>
                        <el-table-column prop="actualPrice" label="优惠价" align="center">
                            <template slot-scope="scope">￥{{ scope.row.actualPrice }}</template>
                        </el-table-column>
                        <el-table-column prop="saving" label="每期节省" align="center">
                            <template slot-scope="scope">
                                <span style="color: #67c23a;">省￥{{ scope.row.saving }}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: 'StoreCardList',
    data() {
        return {
            // 店铺相关
            storeList: [],
            filteredStoreList: [],
            selectedStore: null,
            storeLoading: false,
            storeSearchKeyword: '',
            storeStatusFilter: '',
            
            // 卡片列表相关
            storeCardList: [],
            allStoreCards: [], // 缓存所有店铺卡片数据
            availableCards: [],
            loading: false,
            
            // 搜索筛选相关
            searchForm: {
                cardname: '',
                cardclassid: '',
                cardScopeType: ''
            },
            
            // 分页相关
            pagination: {
                pagenum: 1,
                pagesize: 10,
                total: 0
            },
            
            // 添加卡片弹窗
            addCardDialogVisible: false,
            addCardForm: {
                cardId: '',
                price: 0,
                sortOrder: 0,
                isActive: 1,
                isShow: 1
            },
            addCardRules: {
                cardId: [
                    { required: true, message: '请选择会员卡', trigger: 'change' }
                ],
                price: [
                    { required: true, message: '请输入价格', trigger: 'blur' },
                    { type: 'number', min: 0, message: '价格不能小于0', trigger: 'blur' }
                ]
            },
            
            // 编辑卡片弹窗
            editCardDialogVisible: false,
            editCardForm: {
                id: '',
                cardId: '',
                cardname: '',
                classname: '',
                price: 0,
                days: 0,
                storeDesc: '',
                sortOrder: 0,
                isActive: 1,
                isShow: 1
            },
            editCardRules: {
                price: [
                    { required: true, message: '请输入价格', trigger: 'blur' },
                    { type: 'number', min: 0, message: '价格不能小于0', trigger: 'blur' }
                ]
            },
            
            submitting: false,

            // 自动续费详情弹窗
            autoRenewalVisible: false,
            autoRenewalData: null,
            autoRenewalDetails: []
        }
    },
    created() {
        this.loadStores()
    },
    methods: {
        // 加载店铺列表
        // 显示自动续费配置详情
        async showAutoRenewalDetail(row) {
            this.autoRenewalData = row
            this.autoRenewalVisible = true
            // 加载代扣明细
            try {
                const { data: res } = await this.$http.get('cardprice/deduct-details', {
                    params: { cardPriceId: row.id }
                })
                if (res.status === 0) {
                    this.autoRenewalDetails = res.data || []
                }
            } catch (e) {
                console.error('加载代扣明细失败:', e)
                this.autoRenewalDetails = []
            }
        },

        async loadStores() {
            this.storeLoading = true
            try {
                const { data: res } = await this.$http.get('store/')
                if (res.status === 0 || res.status === 1) {
                    this.storeList = res.data || []
                    this.filteredStoreList = [...this.storeList]
                    // 自动选择第一个店铺
                    if (this.storeList.length > 0 && !this.selectedStore) {
                        this.selectStore(this.storeList[0])
                    }
                } else {
                    this.$message.error(res.message || '获取店铺列表失败')
                    this.storeList = []
                }
            } catch (error) {
                console.error('获取店铺列表失败:', error)
                this.$message.error('获取店铺列表失败')
                this.storeList = []
            } finally {
                this.storeLoading = false
            }
        },
        
        // 筛选店铺
        filterStores() {
            let filtered = [...this.storeList]
            
            // 按关键词筛选（保留原有搜索功能，虽然界面上移除了搜索框）
            if (this.storeSearchKeyword && this.storeSearchKeyword.trim()) {
                const keyword = this.storeSearchKeyword.toLowerCase()
                filtered = filtered.filter(store => 
                    store.storename.toLowerCase().includes(keyword) ||
                    (store.city && store.city.toLowerCase().includes(keyword)) ||
                    (store.address && store.address.toLowerCase().includes(keyword))
                )
            }
            
            // 按状态筛选（使用isopen字段）
            if (this.storeStatusFilter) {
                filtered = filtered.filter(store => 
                    String(store.isopen) === String(this.storeStatusFilter)
                )
            }
            
            this.filteredStoreList = filtered
        },
        
        // 设置状态筛选
        setStatusFilter(status) {
            this.storeStatusFilter = status
            this.filterStores()
        },
        
        // 清除状态筛选
        clearStatusFilter() {
            this.storeStatusFilter = ''
            this.filterStores()
        },
        
        // 选择店铺
        async selectStore(store) {
            console.log('选择店铺:', store)
            this.selectedStore = store
            // 清空之前的数据
            this.storeCardList = []
            this.allStoreCards = []
            // 重置搜索条件和分页
            this.resetSearchAndPagination()
            // 重新加载店铺卡片数据
            await this.loadStoreCards()
        },
        
        // 加载店铺下的会员卡数据（仅调用API）
        async loadStoreCards() {
            if (!this.selectedStore) return
            
            this.loading = true
            try {
                console.log('=== 开始加载店铺卡片数据 ===')
                console.log('店铺ID:', this.selectedStore.id)
                
                // 使用API获取所有数据
                const { data: res } = await this.$http.get(`cardprice/store/${this.selectedStore.id}`)
                console.log('API原始响应:', res)
                
                if (res.status === 0 || res.status === 1) {
                    let allCardData = []
                    
                    // 处理不同的响应格式
                    if (Array.isArray(res.data)) {
                        allCardData = res.data
                    } else if (res.data && res.data.list) {
                        allCardData = res.data.list.map(item => {
                            if (item.pk && item.fields) {
                                return {
                                    id: item.pk,
                                    ...item.fields
                                }
                            }
                            return item
                        })
                    } else if (res.data) {
                        allCardData = [res.data]
                    }
                    
                    // 确保 isActive 字段为数字类型
                    allCardData = allCardData.map(item => ({
                        ...item,
                        isActive: Number(item.isActive) // 确保为数字类型
                    }))
                    
                    // 过滤掉 isActive = 0 的数据
                    allCardData = allCardData.filter(item => item.isActive !== 0)
                    
                    // 缓存所有数据
                    this.allStoreCards = allCardData
                    console.log('加载完成，总数据量:', allCardData.length)
                    console.log('数据样例（第一条）:', allCardData[0])
                    
                    // 立即处理显示数据
                    this.processDisplayData()
                } else {
                    this.$message.error(res.message || '获取店铺会员卡失败')
                    this.allStoreCards = []
                    this.storeCardList = []
                    this.pagination.total = 0
                }
            } catch (error) {
                console.error('获取店铺会员卡失败:', error)
                this.$message.error('获取店铺会员卡失败')
                this.allStoreCards = []
                this.storeCardList = []
                this.pagination.total = 0
            } finally {
                this.loading = false
            }
        },
        
        // 处理显示数据（纯前端搜索和分页）
        processDisplayData() {
            if (!this.allStoreCards || this.allStoreCards.length === 0) {
                this.storeCardList = []
                this.pagination.total = 0
                return
            }
            
            console.log('=== 开始处理显示数据 ===')
            console.log('原始数据量:', this.allStoreCards.length)
            console.log('当前搜索条件:', this.searchForm)
            
            // 前端搜索筛选
            let filteredData = this.allStoreCards.filter(card => {
                // 过滤掉 isActive = 0 的数据（双重保险）
                if (Number(card.isActive) === 0) {
                    return false
                }
                
                // 按卡名搜索（模糊匹配，不区分大小写）
                if (this.searchForm.cardname && this.searchForm.cardname.trim()) {
                    const searchName = this.searchForm.cardname.trim().toLowerCase()
                    const cardName = (card.cardname || '').toLowerCase()
                    if (!cardName.includes(searchName)) {
                        return false
                    }
                }
                
                // 按卡类型筛选（精确匹配）
                if (this.searchForm.cardclassid && this.searchForm.cardclassid !== '') {
                    if (Number(card.cardclassid) !== Number(this.searchForm.cardclassid)) {
                        return false
                    }
                }
                
                // 按适用范围筛选（精确匹配）
                if (this.searchForm.cardScopeType && this.searchForm.cardScopeType !== '') {
                    if (Number(card.card_scope_type) !== Number(this.searchForm.cardScopeType)) {
                        return false
                    }
                }
                
                return true
            })
            
            console.log('筛选后数据量:', filteredData.length)
            
            // 前端分页
            const total = filteredData.length
            const startIndex = (this.pagination.pagenum - 1) * this.pagination.pagesize
            const endIndex = startIndex + this.pagination.pagesize
            const pageData = filteredData.slice(startIndex, endIndex)
            
            this.storeCardList = pageData
            this.pagination.total = total
            
            console.log('=== 分页结果 ===')
            console.log('筛选后总数:', total)
            console.log('当前页:', this.pagination.pagenum)
            console.log('每页大小:', this.pagination.pagesize)
            console.log('当前页数据量:', pageData.length)
            console.log('显示范围:', startIndex + 1, '-', Math.min(endIndex, total))
        },
        
        // 加载可添加的会员卡列表
        async loadAvailableCards() {
            if (!this.selectedStore) return
            
            try {
                // 获取所有会员卡 - 修复API调用
                const { data: res } = await this.$http.get('cardlist/', {
                    params: {
                        pageNum: 1,
                        pageSize: 1000
                    }
                })
                
                if (res.code === 0 || res.status === 0) {
                    const allCards = res.data || []
                    const existingCardIds = this.storeCardList.map(item => item.cardId || item.card_id)
                    this.availableCards = allCards.filter(card => !existingCardIds.includes(card.id))
                } else {
                    this.$message.error(res.msg || res.message || '获取会员卡列表失败')
                    this.availableCards = []
                }
            } catch (error) {
                console.error('获取会员卡列表失败:', error)
                this.$message.error('获取会员卡列表失败')
                this.availableCards = []
            }
        },
        
        // 打开添加卡片弹窗
        async openAddCardDialog() {
            if (!this.selectedStore) {
                this.$message.warning('请先选择店铺')
                return
            }
            
            await this.loadAvailableCards()
            if (this.availableCards.length === 0) {
                this.$message.info('该店铺已添加所有可用的会员卡')
                return
            }
            
            this.addCardDialogVisible = true
        },
        
        // 选择会员卡时的回调
        onCardSelect(cardId) {
            // 可以在这里添加一些逻辑，比如根据卡片类型设置默认价格
        },
        
        // 确认添加会员卡
        async confirmAddCard() {
            this.$refs.addCardForm.validate(async (valid) => {
                if (!valid) return
                
                this.submitting = true
                try {
                    const { data: res } = await this.$http.post('cardprice/add', {
                        cardId: this.addCardForm.cardId,
                        storeId: this.selectedStore.id,
                        price: this.addCardForm.price,
                        sortOrder: this.addCardForm.sortOrder || 0,
                        isActive: Number(this.addCardForm.isActive), // 确保为数字类型
                        isShow: Number(this.addCardForm.isShow) // 添加显示状态字段
                    })
                    
                    if (res.status === 0) {
                        this.$message.success('添加成功')
                        this.addCardDialogVisible = false
                        await this.loadStoreCards()
                    } else {
                        this.$message.error(res.message || '添加失败')
                    }
                } catch (error) {
                    console.error('添加会员卡失败:', error)
                    this.$message.error('添加失败')
                } finally {
                    this.submitting = false
                }
            })
        },
        
        // 编辑店铺会员卡
        editStoreCard(row) {
            this.editCardForm = {
                id: row.id,
                cardId: row.cardId,
                cardname: row.cardname,
                classname: row.classname,
                price: row.price,
                days: row.days || 0,
                storeDesc: row.storeDesc || '',
                sortOrder: row.sortOrder || 0,
                isActive: Number(row.isActive), // 确保为数字类型
                isShow: row.isShow !== undefined ? Number(row.isShow) : (row.is_show !== undefined ? Number(row.is_show) : 1)
            }
            this.editCardDialogVisible = true
        },
        
        // 确认编辑会员卡
        async confirmEditCard() {
            this.$refs.editCardForm.validate(async (valid) => {
                if (!valid) return
                
                this.submitting = true
                try {
                    const { data: res } = await this.$http.post('cardprice/update', {
                        id: this.editCardForm.id,
                        price: this.editCardForm.price,
                        days: this.editCardForm.days || 0,
                        storeDesc: this.editCardForm.storeDesc || '',
                        sortOrder: this.editCardForm.sortOrder || 0,
                        isActive: Number(this.editCardForm.isActive), // 确保为数字类型
                        isShow: Number(this.editCardForm.isShow) // 添加显示状态字段
                    })
                    
                    if (res.status === 0) {
                        this.$message.success('更新成功')
                        this.editCardDialogVisible = false
                        await this.loadStoreCards()
                    } else {
                        this.$message.error(res.message || '更新失败')
                    }
                } catch (error) {
                    console.error('更新会员卡失败:', error)
                    this.$message.error('更新失败')
                } finally {
                    this.submitting = false
                }
            })
        },
        
        // 切换卡片状态
        async toggleCardStatus(row) {
            const newStatus = Number(row.isActive) // 确保为数字类型
            const statusText = newStatus === 1 ? '启用' : '禁用'
            
            try {
                const { data: res } = await this.$http.post('cardprice/toggle', {
                    id: row.id,
                    isActive: newStatus // 已经是数字类型
                })
                
                if (res.status === 0) {
                    this.$message.success(`${statusText}成功`)
                } else {
                    this.$message.error(res.message || `${statusText}失败`)
                    // 如果操作失败，需要恢复开关状态
                    row.isActive = newStatus === 1 ? 0 : 1
                }
            } catch (error) {
                console.error(`${statusText}会员卡失败:`, error)
                this.$message.error(`${statusText}失败`)
                // 如果操作失败，需要恢复开关状态
                row.isActive = newStatus === 1 ? 0 : 1
            }
        },
        
        // 删除店铺会员卡
        deleteStoreCard(row) {
            this.$confirm(`确定要从 ${this.selectedStore.storename} 移除会员卡 "${row.cardname}" 吗？`, '确认移除', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                try {
                    const { data: res } = await this.$http.post('cardprice/delete', {
                        id: row.id
                    })
                    
                    if (res.status === 0) {
                        this.$message.success('移除成功')
                        await this.loadStoreCards()
                    } else {
                        this.$message.error(res.message || '移除失败')
                    }
                } catch (error) {
                    console.error('移除会员卡失败:', error)
                    this.$message.error('移除失败')
                }
            }).catch(() => {
                // 用户取消操作
            })
        },
        
        // 重置添加表单
        resetAddCardForm() {
            this.addCardForm = {
                cardId: '',
                price: 0,
                sortOrder: 0,
                isActive: 1,
                isShow: 1
            }
            if (this.$refs.addCardForm) {
                this.$refs.addCardForm.resetFields()
            }
        },
        
        // 重置编辑表单
        resetEditCardForm() {
            this.editCardForm = {
                id: '',
                cardId: '',
                cardname: '',
                classname: '',
                price: 0,
                days: 0,
                storeDesc: '',
                sortOrder: 0,
                isActive: 1,
                isShow: 1
            }
            if (this.$refs.editCardForm) {
                this.$refs.editCardForm.resetFields()
            }
        },
        
        // 获取卡片范围类型名称
        getCardScopeTypeName(type) {
            const typeMap = {
                1: '单店卡',
                2: '城市通卡',
                3: '全国通卡',
                4: '自定义'
            }
            return typeMap[type] || '未知'
        },
        
        // 获取卡片范围类型标签样式
        getCardScopeTypeTag(type) {
            const tagMap = {
                1: 'info',
                2: 'success',
                3: 'warning',
                4: 'primary'
            }
            return tagMap[type] || 'info'
        },
        
        // 格式化日期
        formatDate(dateString) {
            if (!dateString) return '-'
            const date = new Date(dateString)
            return date.toLocaleString('zh-CN', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit'
            })
        },
        
        // 获取店铺状态文本
        getStoreStatusText(status) {
            const statusMap = {
                1: '营业中',
                2: '已关闭', 
                3: '装修中'
            }
            return statusMap[status] || '未知状态'
        },
        
        // 获取店铺状态标签类型
        getStoreStatusType(status) {
            const typeMap = {
                1: 'success',  // 营业中 - 绿色
                2: 'danger',   // 已关闭 - 红色
                3: 'warning'   // 装修中 - 橙色
            }
            return typeMap[status] || 'info'
        },
        
        // 获取城市颜色
        getCityColor(city) {
            if (!city) return '#909399'
            
            // 根据城市名称生成颜色
            const colors = [
                '#409EFF', // 蓝色
                '#67C23A', // 绿色
                '#E6A23C', // 橙色
                '#F56C6C', // 红色
                '#909399', // 灰色
                '#606266', // 深灰
                '#303133', // 黑色
                '#13CE66', // 青绿
                '#FF4949', // 亮红
                '#1890FF', // 天蓝
                '#52C41A', // 草绿
                '#FA8C16', // 金橙
                '#EB2F96', // 洋红
                '#722ED1', // 紫色
                '#13C2C2'  // 青色
            ]
            
            // 使用城市名称的哈希值来选择颜色
            let hash = 0
            for (let i = 0; i < city.length; i++) {
                hash = city.charCodeAt(i) + ((hash << 5) - hash)
            }
            const index = Math.abs(hash) % colors.length
            return colors[index]
        },
        
        // 获取卡片类型名称
        getCardClassName(cardclassid) {
            const classMap = {
                1: '时间卡',
                2: '次卡',
                3: '体验卡',
                4: '学生卡',
                5: '女神卡',
                6: '店主卡',
                7: '私教卡',
                9: '早鸟卡',
                8: '其他'
            }
            return classMap[cardclassid] || '未知类型'
        },
        
        // 获取卡片类型标签颜色
        getCardClassTypeTag(cardclassid) {
            const typeMap = {
                1: 'primary',   // 时间卡 - 蓝色
                2: '',   // 次卡 - 绿色
                3: 'success',   // 体验卡 - 绿色
                4: 'warning',   // 学生卡 - 橙色
                5: 'danger',    // 女神卡 - 红色
                6: 'info',      // 店主卡 - 灰色
                7: '',          // 私教卡 - 默认
                9: '',       // 其他 - 黄色
                8: 'info'       // 其他 - 灰色
            }
            return typeMap[cardclassid] || 'info'
        },
        
        // 重置搜索条件和分页
        resetSearchAndPagination() {
            this.searchForm = {
                cardname: '',
                cardclassid: '',
                cardScopeType: ''
            }
            this.pagination.pagenum = 1
            this.pagination.total = 0
        },
        
        // 搜索处理（纯前端，不调用API）
        handleSearch() {
            console.log('=== 执行前端搜索 ===')
            console.log('搜索表单数据:', JSON.stringify(this.searchForm))
            console.log('卡名:', this.searchForm.cardname)
            console.log('卡类型:', this.searchForm.cardclassid, '类型:', typeof this.searchForm.cardclassid)
            console.log('适用范围:', this.searchForm.cardScopeType, '类型:', typeof this.searchForm.cardScopeType)
            
            // 重置到第一页
            this.pagination.pagenum = 1
            // 立即处理显示数据（不调用API）
            this.processDisplayData()
        },
        
        // 重置搜索（纯前端，不调用API）
        resetSearch() {
            console.log('重置搜索条件')
            this.searchForm = {
                cardname: '',
                cardclassid: '',
                cardScopeType: ''
            }
            this.pagination.pagenum = 1
            // 立即处理显示数据（不调用API）
            this.processDisplayData()
        },
        
        // 分页大小改变（纯前端，不调用API）
        handleSizeChange(newSize) {
            console.log('改变分页大小:', newSize)
            this.pagination.pagesize = newSize
            this.pagination.pagenum = 1
            // 立即处理显示数据（不调用API）
            this.processDisplayData()
        },
        
        // 当前页改变（纯前端，不调用API）
        handleCurrentChange(newPage) {
            console.log('改变当前页:', newPage)
            this.pagination.pagenum = newPage
            // 立即处理显示数据（不调用API）
            this.processDisplayData()
        }
    }
}
</script>

<style scoped>
.store-card-list {
    padding: 20px;
}

.breadcrumb {
    margin-bottom: 20px;
}

.store-card-container {
    display: flex;
    min-height: 600px;
    gap: 20px;
}

/* 左侧店铺选择器 */
.store-selector {
    width: 300px;
    border-right: 1px solid #e6e6e6;
    padding-right: 20px;
}

.selector-header {
    margin-bottom: 15px;
}

.selector-header h3 {
    margin: 0 0 10px 0;
    font-size: 16px;
    color: #303133;
}

.store-list {
    height: 500px;
}

.store-item {
    padding: 12px;
    border: 1px solid #e6e6e6;
    border-radius: 6px;
    margin-bottom: 8px;
    cursor: pointer;
    transition: all 0.3s ease;
    background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.store-item:hover {
    border-color: #409eff;
    background: linear-gradient(135deg, #f0f9ff 0%, #e6f7ff 100%);
    box-shadow: 0 4px 12px rgba(64, 158, 255, 0.15);
    transform: translateY(-2px);
}

.store-item.active {
    border-color: #409eff;
    background: linear-gradient(135deg, #ecf5ff 0%, #d4edda 100%);
    box-shadow: 0 4px 16px rgba(64, 158, 255, 0.25);
    transform: translateY(-1px);
}

.store-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 6px;
}

.store-name {
    font-weight: 600;
    color: #303133;
    font-size: 14px;
    line-height: 1.3;
    flex: 1;
    margin-right: 6px;
}

.store-status {
    flex-shrink: 0;
}

.store-filters {
    margin-bottom: 16px;
    display: flex;
    flex-direction: column;
    gap: 8px;
}

/* 状态按钮样式 */
.store-status-buttons {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: 6px;
    margin-top: 8px;
    padding: 8px;
    background-color: #f8f9fa;
    border-radius: 8px;
    border: 1px solid #e9ecef;
}

.store-status-buttons .el-button {
    border-radius: 12px;
    font-weight: 500;
    transition: all 0.3s ease;
    font-size: 12px;
    padding: 4px 8px;
    min-width: auto;
}

.store-status-buttons .el-button i {
    margin-right: 2px;
    font-size: 12px;
}

/* 激活状态的按钮样式 */
.active-status-btn {
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2) !important;
    transform: translateY(-1px);
    font-weight: 600;
}

/* 营业中按钮 - 绿色（与success标签颜色一致） */
.store-status-buttons .el-button--success {
    background-color: #67c23a;
    border-color: #67c23a;
    color: white;
}

.store-status-buttons .el-button--success:hover {
    background-color: #85ce61;
    border-color: #85ce61;
}

.store-status-buttons .el-button--success:focus {
    background-color: #67c23a;
    border-color: #67c23a;
}

/* 装修中按钮 - 橙色（与warning标签颜色一致） */
.store-status-buttons .el-button--warning {
    background-color: #e6a23c;
    border-color: #e6a23c;
    color: white;
}

.store-status-buttons .el-button--warning:hover {
    background-color: #ebb563;
    border-color: #ebb563;
}

.store-status-buttons .el-button--warning:focus {
    background-color: #e6a23c;
    border-color: #e6a23c;
}

/* 已关闭按钮 - 红色（与danger标签颜色一致） */
.store-status-buttons .el-button--danger {
    background-color: #f56c6c;
    border-color: #f56c6c;
    color: white;
}

.store-status-buttons .el-button--danger:hover {
    background-color: #f78989;
    border-color: #f78989;
}

.store-status-buttons .el-button--danger:focus {
    background-color: #f56c6c;
    border-color: #f56c6c;
}

/* 默认状态按钮 - 根据按钮类型显示不同颜色 */
.store-status-buttons .el-button--default {
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    font-weight: 500;
}

/* 营业中按钮未选中状态 - 浅绿色 */
.store-status-buttons .el-button--default:nth-child(1) {
    background-color: #f0f9ff;
    border-color: #a7f3d0;
    color: #059669;
}

.store-status-buttons .el-button--default:nth-child(1):hover {
    background-color: #dcfce7;
    border-color: #86efac;
    color: #047857;
    transform: translateY(-1px);
    box-shadow: 0 2px 6px rgba(5, 150, 105, 0.2);
}

/* 装修中按钮未选中状态 - 浅橙色 */
.store-status-buttons .el-button--default:nth-child(2) {
    background-color: #fffbeb;
    border-color: #fed7aa;
    color: #d97706;
}

.store-status-buttons .el-button--default:nth-child(2):hover {
    background-color: #fef3c7;
    border-color: #fbbf24;
    color: #b45309;
    transform: translateY(-1px);
    box-shadow: 0 2px 6px rgba(217, 119, 6, 0.2);
}

/* 已关闭按钮未选中状态 - 浅红色 */
.store-status-buttons .el-button--default:nth-child(3) {
    background-color: #fef2f2;
    border-color: #fecaca;
    color: #dc2626;
}

.store-status-buttons .el-button--default:nth-child(3):hover {
    background-color: #fee2e2;
    border-color: #f87171;
    color: #b91c1c;
    transform: translateY(-1px);
    box-shadow: 0 2px 6px rgba(220, 38, 38, 0.2);
}

/* 通用默认按钮样式（如果不是前3个按钮） */
.store-status-buttons .el-button--default:not(:nth-child(1)):not(:nth-child(2)):not(:nth-child(3)) {
    background-color: #ffffff;
    border-color: #d0d7de;
    color: #656d76;
}

.store-status-buttons .el-button--default:not(:nth-child(1)):not(:nth-child(2)):not(:nth-child(3)):hover {
    background-color: #f6f8fa;
    border-color: #8c959f;
    color: #24292f;
    transform: translateY(-1px);
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}

/* 全部按钮样式 */
.store-status-buttons .el-button--info {
    background-color: transparent;
    border-color: #909399;
    color: #909399;
    font-size: 11px;
}

.store-status-buttons .el-button--info:hover {
    background-color: #909399;
    border-color: #909399;
    color: white;
}

.store-search {
    width: 100%;
}

.store-status-filter {
    width: 100%;
}

.store-info {
    margin-bottom: 6px;
}

.store-city {
    font-size: 12px;
    font-weight: 500;
    margin-bottom: 3px;
    display: flex;
    align-items: center;
    gap: 3px;
}

.store-city i {
    font-size: 11px;
}

.store-address {
    font-size: 11px;
    color: #666;
    display: flex;
    align-items: center;
    gap: 3px;
    margin-bottom: 3px;
    line-height: 1.2;
}

.store-address i {
    font-size: 10px;
    color: #999;
}

.store-extra {
    font-size: 11px;
    color: #409eff;
    display: flex;
    align-items: center;
    gap: 3px;
    font-weight: 500;
}

.store-extra i {
    font-size: 10px;
}

/* 右侧卡片列表区域 */
.card-list-area {
    flex: 1;
    display: flex;
    flex-direction: column;
}

.no-store-selected {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    margin: 0;
    font-size: 18px;
    color: #303133;
}

/* 工具栏样式 */
.toolbar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 20px;
    background: #f8f9fa;
    border-bottom: 1px solid #e9ecef;
    margin-bottom: 16px;
}

/* 健身主题工具栏 */
.fitness-header {
    position: relative;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%);
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 8px 32px rgba(102, 126, 234, 0.3);
    border: none;
    margin-bottom: 20px;
}

/* 健身背景容器 */
.fitness-background {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    overflow: hidden;
    z-index: 1;
}

/* 健身图标动画 */
.fitness-icons {
    position: absolute;
    width: 100%;
    height: 100%;
    opacity: 0.15;
}

.fitness-icon {
    position: absolute;
    font-size: 24px;
    animation-duration: 8s;
    animation-iteration-count: infinite;
    animation-timing-function: ease-in-out;
}

.fitness-icon.dumbbell {
    top: 20%;
    left: 10%;
    animation-name: float1;
    animation-delay: 0s;
}

.fitness-icon.running {
    top: 60%;
    left: 20%;
    animation-name: float2;
    animation-delay: 1s;
}

.fitness-icon.muscle {
    top: 30%;
    right: 15%;
    animation-name: float3;
    animation-delay: 2s;
}

.fitness-icon.heart {
    top: 70%;
    right: 25%;
    animation-name: pulse;
    animation-delay: 3s;
    animation-duration: 2s;
}

.fitness-icon.trophy {
    top: 40%;
    left: 50%;
    animation-name: bounce;
    animation-delay: 4s;
    animation-duration: 3s;
}

/* 波浪动画 */
.fitness-waves {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0.1;
}

.wave {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 200%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255,255,255,0.4), transparent);
    animation: wave-move 6s linear infinite;
}

.wave1 {
    animation-delay: 0s;
}

.wave2 {
    animation-delay: 2s;
    opacity: 0.05;
}

.wave3 {
    animation-delay: 4s;
    opacity: 0.03;
}

/* 确保内容在背景之上 */
.fitness-header .store-title,
.fitness-header .toolbar-actions {
    position: relative;
    z-index: 2;
}

.fitness-header .store-title h3 {
    color: #ffffff;
    text-shadow: 0 2px 4px rgba(0,0,0,0.3);
    font-weight: 600;
    margin: 0;
    font-size: 18px;
}

.fitness-header .store-title .card-count {
    color: rgba(255,255,255,0.9);
    text-shadow: 0 1px 2px rgba(0,0,0,0.3);
    background: rgba(255,255,255,0.2);
    padding: 4px 12px;
    border-radius: 20px;
    backdrop-filter: blur(10px);
    border: 1px solid rgba(255,255,255,0.3);
    font-size: 14px;
    margin-left: 10px;
}

.store-title {
    display: flex;
    align-items: center;
}

.toolbar-actions {
    display: flex;
    gap: 10px;
}

/* 动画关键帧 */
@keyframes float1 {
    0%, 100% { transform: translateY(0px) rotate(0deg); }
    25% { transform: translateY(-10px) rotate(5deg); }
    50% { transform: translateY(-20px) rotate(0deg); }
    75% { transform: translateY(-10px) rotate(-5deg); }
}

@keyframes float2 {
    0%, 100% { transform: translateX(0px) translateY(0px); }
    25% { transform: translateX(10px) translateY(-15px); }
    50% { transform: translateX(20px) translateY(-10px); }
    75% { transform: translateX(10px) translateY(-5px); }
}

@keyframes float3 {
    0%, 100% { transform: translateY(0px) scale(1); }
    33% { transform: translateY(-15px) scale(1.1); }
    66% { transform: translateY(-25px) scale(0.9); }
}

@keyframes pulse {
    0%, 100% { transform: scale(1); }
    50% { transform: scale(1.3); }
}

@keyframes bounce {
    0%, 100% { transform: translateY(0px); }
    25% { transform: translateY(-20px); }
    50% { transform: translateY(-30px); }
    75% { transform: translateY(-15px); }
}

@keyframes wave-move {
    0% { transform: translateX(-100%); }
    100% { transform: translateX(0%); }
}

/* 表格样式 */
.card-name-cell {
    display: flex;
    align-items: center;
    gap: 8px;
}

.card-name {
    font-weight: 500;
}

.price-text {
    font-weight: 500;
    color: #e6a23c;
}

.sort-order {
    font-weight: 500;
    color: #409eff;
    background: #ecf5ff;
    padding: 2px 8px;
    border-radius: 12px;
    font-size: 12px;
}

/* 弹窗样式 */
.dialog-footer {
    text-align: right;
}

/* 响应式设计 */
@media (max-width: 1200px) {
    .store-card-container {
        flex-direction: column;
        height: auto;
    }
    
    .store-selector {
        width: 100%;
        border-right: none;
        border-bottom: 1px solid #e6e6e6;
        padding-right: 0;
        padding-bottom: 20px;
        margin-bottom: 20px;
    }
    
    .store-list {
        height: 200px;
    }
}

/* 搜索筛选区域样式 */
.search-filter-area {
    margin-bottom: 16px;
    padding: 16px;
    background: #f8f9fa;
    border-radius: 6px;
    border: 1px solid #e9ecef;
}

.total-info {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    height: 32px;
    font-size: 14px;
    color: #606266;
    font-weight: 500;
}

/* 分页容器样式 */
.pagination-container {
    margin-top: 20px;
    padding: 16px 0;
    text-align: center;
    border-top: 1px solid #e6e6e6;
    background: #fafafa;
}

/* 卡片名称单元格样式 */
.card-name-cell {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.card-name {
    font-weight: 500;
    color: #303133;
}

/* 价格文本样式 */
.price-text {
    font-weight: 600;
    color: #e6a23c;
}

</style>
